import { SourceType as CitationTypes, CitationPubTypeEnum } from '../types';
var validateContributors = function validateContributors(contributors) {
  if (!contributors.length) return true;
  for (var index = 0; index < contributors.length; index++) {
    if (!contributors[index].firstName || !contributors[index].lastName) return true;
  }
  return false;
};
var validateWebsiteFields = function validateWebsiteFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data = citationData.data,
    pubonline = _citationData$data.pubonline,
    website = _citationData$data.website;
  var title = pubonline.title,
    url = pubonline.url,
    year = pubonline.year,
    yearaccessed = pubonline.yearaccessed;
  if (!title || !url || !year || !yearaccessed || !website.title) return true;
  return validateContributors(contributors);
};
var validateBookFields = function validateBookFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data2 = citationData.data,
    pubnonperiodical = _citationData$data2.pubnonperiodical,
    pubtype = _citationData$data2.pubtype;
  var city = pubnonperiodical.city,
    publisher = pubnonperiodical.publisher,
    state = pubnonperiodical.state,
    title = pubnonperiodical.title,
    year = pubnonperiodical.year;
  if (!city || !publisher || !state || !year) return true;
  if (pubtype.suffix === CitationPubTypeEnum.PUBONLINE) {
    var _citationData$data$Ci = citationData.data[CitationPubTypeEnum.PUBONLINE],
      _year = _citationData$data$Ci.year,
      yearaccessed = _citationData$data$Ci.yearaccessed;
    if (!_year || !yearaccessed) return true;
  } else if (pubtype.suffix === CitationPubTypeEnum.PUBDATABASE) {
    var _yearaccessed = citationData.data[CitationPubTypeEnum.PUBDATABASE].yearaccessed;
    if (!title || !_yearaccessed) return true;
  } else if (!pubtype.suffix && !title) return true;
  return validateContributors(contributors);
};
var validateEditorialFields = function validateEditorialFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data3 = citationData.data,
    pubmagazine = _citationData$data3.pubmagazine,
    pubnewspaper = _citationData$data3.pubnewspaper,
    pubonline = _citationData$data3.pubonline,
    pubdatabase = _citationData$data3.pubdatabase;
  if (pubmagazine || pubnewspaper) {
    var pubInfo = pubmagazine ? CitationPubTypeEnum.PUBMAGAZINE : CitationPubTypeEnum.PUBNEWSPAPER;
    var year = citationData.data[pubInfo].year;
    if (!year) return true;
  }
  if (pubonline) {
    var _citationData$data$Ci2 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      title = _citationData$data$Ci2.title,
      url = _citationData$data$Ci2.url,
      _year2 = _citationData$data$Ci2.year,
      yearaccessed = _citationData$data$Ci2.yearaccessed;
    if (!title || !url || !_year2 || !yearaccessed) return true;
  }
  if (pubdatabase && !pubdatabase.yearaccessed) return true;
  return validateContributors(contributors);
};
var validatePhotoFormFields = function validatePhotoFormFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data4 = citationData.data,
    pubnonperiodical = _citationData$data4.pubnonperiodical,
    pubonline = _citationData$data4.pubonline,
    pubdatabase = _citationData$data4.pubdatabase,
    photo = _citationData$data4.photo;
  if (photo) {
    var year = photo.year;
    if (!year) return true;
  }
  if (pubnonperiodical) {
    var title = pubnonperiodical.title,
      publisher = pubnonperiodical.publisher,
      city = pubnonperiodical.city,
      state = pubnonperiodical.state,
      _year3 = pubnonperiodical.year,
      start = pubnonperiodical.start,
      end = pubnonperiodical.end;
    if (!start || !publisher || !_year3 || !city || !state || !end || !title) return true;
  }
  if (pubonline) {
    var _title = pubonline.title,
      url = pubonline.url,
      _year4 = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!url || !_year4 || !yearaccessed || !_title) return true;
  }
  if (pubdatabase && !pubdatabase.yearaccessed) {
    return true;
  }
  return validateContributors(contributors);
};
var validateCourtcaseFormFields = function validateCourtcaseFormFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data5 = citationData.data,
    pubonline = _citationData$data5.pubonline,
    pubdatabase = _citationData$data5.pubdatabase,
    pubfederal = _citationData$data5.pubfederal;
  if (pubfederal) {
    var source = pubfederal.source,
      vol = pubfederal.vol;
    if (!source || !vol) return true;
  }
  if (pubonline) {
    var title = pubonline.title,
      url = pubonline.url,
      year = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!url || !year || !yearaccessed || !title) return true;
  }
  if (pubdatabase && !pubdatabase.yearaccessed) {
    return true;
  }
  return !contributors;
};
var validateLectureFormFields = function validateLectureFormFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data6 = citationData.data,
    pubnonperiodical = _citationData$data6.pubnonperiodical,
    pubonline = _citationData$data6.pubonline,
    pubdatabase = _citationData$data6.pubdatabase,
    publive = _citationData$data6.publive;
  if (publive) {
    var year = publive.year;
    if (!year) return true;
  }
  if (pubnonperiodical) {
    var publisher = pubnonperiodical.publisher,
      city = pubnonperiodical.city,
      state = pubnonperiodical.state,
      _year5 = pubnonperiodical.year,
      start = pubnonperiodical.start,
      end = pubnonperiodical.end;
    if (!start || !publisher || !_year5 || !city || !state || !end) return true;
  }
  if (pubonline) {
    var title = pubonline.title,
      url = pubonline.url,
      _year6 = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!url || !_year6 || !yearaccessed || !title) return true;
  }
  if (pubdatabase && !pubdatabase.yearaccessed) {
    return true;
  }
  return validateContributors(contributors);
};
var validateChapterFields = function validateChapterFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data7 = citationData.data,
    chapter = _citationData$data7.chapter,
    pubnonperiodical = _citationData$data7.pubnonperiodical,
    pubtype = _citationData$data7.pubtype;
  var city = pubnonperiodical.city,
    publisher = pubnonperiodical.publisher,
    state = pubnonperiodical.state,
    title = pubnonperiodical.title,
    year = pubnonperiodical.year;
  if (!city || !publisher || !state || !title || !year || !chapter.title) return true;
  if (pubtype.suffix === CitationPubTypeEnum.PUBREPRINT) {
    var _citationData$data$Ci3 = citationData.data[CitationPubTypeEnum.PUBREPRINT],
      _city = _citationData$data$Ci3.city,
      _publisher = _citationData$data$Ci3.publisher,
      _state = _citationData$data$Ci3.state,
      _year7 = _citationData$data$Ci3.year;
    if (!_city || !_publisher || !_state || !_year7) return true;
  } else if (pubtype.suffix === CitationPubTypeEnum.PUBONLINE) {
    var _citationData$data$Ci4 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      _year8 = _citationData$data$Ci4.year,
      yearaccessed = _citationData$data$Ci4.yearaccessed;
    if (!_year8 || !yearaccessed) return true;
  } else if (pubtype.suffix === CitationPubTypeEnum.PUBDATABASE) {
    var _yearaccessed2 = citationData.data[CitationPubTypeEnum.PUBDATABASE].yearaccessed;
    if (!_yearaccessed2) return true;
  }
  return validateContributors(contributors);
};
var validateIntroductionFields = function validateIntroductionFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data8 = citationData.data,
    pubnonperiodical = _citationData$data8.pubnonperiodical,
    pubtype = _citationData$data8.pubtype;
  var city = pubnonperiodical.city,
    publisher = pubnonperiodical.publisher,
    state = pubnonperiodical.state,
    year = pubnonperiodical.year,
    title = pubnonperiodical.title,
    start = pubnonperiodical.start,
    end = pubnonperiodical.end;
  if (!title || !start || !end || !city || !publisher || !state || !year) return true;
  if (pubtype.suffix === CitationPubTypeEnum.PUBONLINE) {
    var _citationData$data$Ci5 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      _year9 = _citationData$data$Ci5.year,
      yearaccessed = _citationData$data$Ci5.yearaccessed,
      _title2 = _citationData$data$Ci5.title,
      url = _citationData$data$Ci5.url;
    if (!_year9 || !yearaccessed || !_title2 || !url) return true;
  } else if (pubtype.suffix === CitationPubTypeEnum.PUBDATABASE) {
    var _yearaccessed3 = citationData.data[CitationPubTypeEnum.PUBDATABASE].yearaccessed;
    if (!_yearaccessed3) return true;
  }
  return validateContributors(contributors);
};
var validateJournalFields = function validateJournalFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data9 = citationData.data,
    pubjournal = _citationData$data9.pubjournal,
    pubtype = _citationData$data9.pubtype;
  if (pubjournal && !pubjournal.year) return true;
  if (pubtype.suffix === CitationPubTypeEnum.PUBABSTRACTSJOURNAL) {
    var year = citationData.data[CitationPubTypeEnum.PUBABSTRACTSJOURNAL].year;
    if (!year) return true;
  } else if (pubtype.suffix === CitationPubTypeEnum.PUBONLINE) {
    var _citationData$data$Ci6 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      title = _citationData$data$Ci6.title,
      url = _citationData$data$Ci6.url,
      _year10 = _citationData$data$Ci6.year,
      yearaccessed = _citationData$data$Ci6.yearaccessed;
    if (!title || !url || !_year10 || !yearaccessed) return true;
  } else if (pubtype.suffix === CitationPubTypeEnum.PUBDATABASE) {
    var _yearaccessed4 = citationData.data[CitationPubTypeEnum.PUBDATABASE].yearaccessed;
    if (_yearaccessed4) return true;
  }
  return validateContributors(contributors);
};
var validateDigitalFileFields = function validateDigitalFileFields(citationData) {
  var contributors = citationData.contributors;
  var pubother = citationData.data.pubother;
  var city = pubother.city,
    org = pubother.org,
    year = pubother.year;
  if (!city || !org || !year) return true;
  return validateContributors(contributors);
};
var validateDissertationThesisFields = function validateDissertationThesisFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data10 = citationData.data,
    dissertation = _citationData$data10.dissertation,
    pubnonperiodical = _citationData$data10.pubnonperiodical,
    pubonline = _citationData$data10.pubonline,
    pubjournal = _citationData$data10.pubjournal,
    pubdatabase = _citationData$data10.pubdatabase,
    thesis = _citationData$data10.thesis;
  if (dissertation) {
    var university = dissertation.university,
      yeargiven = dissertation.yeargiven;
    if (!university || !yeargiven) return true;
  } else if (thesis) {
    var _university = thesis.university,
      _yeargiven = thesis.yeargiven;
    if (!_university || !_yeargiven) return true;
  }
  if (pubnonperiodical) {
    var city = pubnonperiodical.city,
      end = pubnonperiodical.end,
      start = pubnonperiodical.start,
      state = pubnonperiodical.state,
      year = pubnonperiodical.year,
      publisher = pubnonperiodical.publisher;
    if (!city || !end || !year || !start || !state || !publisher) return true;
  }
  if (pubonline) {
    var title = pubonline.title,
      url = pubonline.url,
      _year11 = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!title || !url || !_year11 || !yearaccessed) return true;
  }
  if (pubjournal && !pubjournal.year) {
    return true;
  }
  if (pubdatabase && !pubdatabase.yearaccessed) {
    return true;
  }
  return validateContributors(contributors);
};
var validateDisserationAbstractFields = function validateDisserationAbstractFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data11 = citationData.data,
    pubjournal = _citationData$data11.pubjournal,
    pubonline = _citationData$data11.pubonline,
    pubdatabase = _citationData$data11.pubdatabase,
    dissertationabstract = _citationData$data11.dissertationabstract;
  if (dissertationabstract) {
    var title = dissertationabstract.title,
      university = dissertationabstract.university,
      yeargiven = dissertationabstract.yeargiven;
    if (!title || !university || !yeargiven) return true;
  }
  if (pubjournal) {
    var year = pubjournal.year;
    if (!year) return true;
  }
  if (pubonline) {
    var _citationData$data$Ci7 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      _title3 = _citationData$data$Ci7.title,
      url = _citationData$data$Ci7.url,
      _year12 = _citationData$data$Ci7.year,
      yearaccessed = _citationData$data$Ci7.yearaccessed;
    if (!_title3 || !url || !_year12 || !yearaccessed) return true;
  }
  if (pubdatabase) {
    var _yearaccessed5 = citationData.data[CitationPubTypeEnum.PUBDATABASE].yearaccessed;
    if (!_yearaccessed5) return true;
  }
  return validateContributors(contributors);
};
var validateFilmFields = function validateFilmFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data12 = citationData.data,
    film = _citationData$data12.film,
    pubonline = _citationData$data12.pubonline,
    pubfilm = _citationData$data12.pubfilm,
    pubdatabase = _citationData$data12.pubdatabase;
  if (!film.mainperformers) return true;
  if (pubonline) {
    var title = pubonline.title,
      url = pubonline.url,
      year = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!title || !url || !year || !yearaccessed) return true;
  }
  if (pubfilm && !pubfilm.distributor) return true;
  if (pubdatabase && !pubdatabase.yearaccessed) return true;
  return validateContributors(contributors);
};
var validateGovtPubFields = function validateGovtPubFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data13 = citationData.data,
    pubnonperiodical = _citationData$data13.pubnonperiodical,
    pubonline = _citationData$data13.pubonline,
    pubdatabase = _citationData$data13.pubdatabase;
  if (pubnonperiodical) {
    var vol = pubnonperiodical.vol,
      publisher = pubnonperiodical.publisher,
      city = pubnonperiodical.city,
      state = pubnonperiodical.state,
      year = pubnonperiodical.year;
    if (!vol || !publisher || !year || !city || !state) return true;
  }
  if (pubonline) {
    var url = pubonline.url,
      _year13 = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!url || !_year13 || !yearaccessed) return true;
  }
  if (pubdatabase && !pubdatabase.yearaccessed) {
    return true;
  }
  return validateContributors(contributors);
};
var validateDigitalImageFields = function validateDigitalImageFields(citationData) {
  var contributors = citationData.contributors;
  var pubonline = citationData.data.pubonline;
  var year = pubonline.year,
    yearaccessed = pubonline.yearaccessed;
  if (!year || !yearaccessed) return true;
  return validateContributors(contributors);
};
var validateBlogFields = function validateBlogFields(citationData) {
  var contributors = citationData.contributors;
  var pubonline = citationData.data.pubonline;
  var year = pubonline.year,
    yearaccessed = pubonline.yearaccessed,
    title = pubonline.title,
    url = pubonline.url;
  if (!year || !yearaccessed || !title || !url) return true;
  return validateContributors(contributors);
};
var validateOnlineDatabaseFields = function validateOnlineDatabaseFields(citationData) {
  var contributors = citationData.contributors;
  var pubdatabase = citationData.data.pubdatabase;
  if (pubdatabase && !pubdatabase.yearaccessed) return true;
  return validateContributors(contributors);
};
var validateReviewFields = function validateReviewFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data14 = citationData.data,
    pubnewspaper = _citationData$data14.pubnewspaper,
    pubjournal = _citationData$data14.pubjournal,
    pubonline = _citationData$data14.pubonline,
    pubdatabase = _citationData$data14.pubdatabase;
  if (pubnewspaper || pubjournal) {
    var _ref = pubnewspaper || pubjournal,
      start = _ref.start,
      end = _ref.end,
      year = _ref.year;
    if (!start || !end || !year) return true;
  }
  if (pubonline) {
    var title = pubonline.title,
      url = pubonline.url,
      _year14 = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!title || !url || !_year14 || !yearaccessed) return true;
  }
  if (pubdatabase && !pubdatabase.year) return true;
  return validateContributors(contributors);
};
var validateInterviewFields = function validateInterviewFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data15 = citationData.data,
    pubmagazine = _citationData$data15.pubmagazine,
    pubnewspaper = _citationData$data15.pubnewspaper,
    pubtvr = _citationData$data15.pubtvr,
    pubonline = _citationData$data15.pubonline,
    pubdatabase = _citationData$data15.pubdatabase;
  if (pubmagazine || pubnewspaper) {
    var _ref2 = pubmagazine || pubnewspaper,
      year = _ref2.year;
    if (!year) return true;
  }
  if (pubonline) {
    var title = pubonline.title,
      url = pubonline.url,
      _year15 = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!title || !url || !_year15 || !yearaccessed) return true;
  }
  if (pubdatabase || pubtvr) {
    var _ref3 = pubdatabase || pubtvr,
      _year16 = _ref3.year;
    if (!_year16) return true;
  }
  return validateContributors(contributors);
};
var validateAdvertisementFields = function validateAdvertisementFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data16 = citationData.data,
    pubmagazine = _citationData$data16.pubmagazine,
    pubnewspaper = _citationData$data16.pubnewspaper,
    pubtvr = _citationData$data16.pubtvr,
    pubonline = _citationData$data16.pubonline;
  if (pubmagazine || pubnewspaper || pubtvr) {
    var _ref4 = pubmagazine || pubnewspaper || pubtvr,
      year = _ref4.year;
    if (!year) return true;
  }
  if (pubonline) {
    var title = pubonline.title,
      url = pubonline.url,
      _year17 = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!title || !url || !_year17 || !yearaccessed) return true;
  }
  return !contributors;
};
var validateLetterFields = function validateLetterFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data17 = citationData.data,
    pubnonperiodical = _citationData$data17.pubnonperiodical,
    pubonline = _citationData$data17.pubonline,
    pubdatabase = _citationData$data17.pubdatabase,
    pubother = _citationData$data17.pubother;
  if (pubdatabase) {
    var yearaccessed = pubdatabase.yearaccessed;
    if (!yearaccessed) return true;
  }
  if (pubonline) {
    var title = pubonline.title,
      url = pubonline.url,
      year = pubonline.year,
      _yearaccessed6 = pubonline.yearaccessed;
    if (!title || !url || !year || !_yearaccessed6) return true;
  }
  if (pubnonperiodical) {
    var _title4 = pubnonperiodical.title,
      publisher = pubnonperiodical.publisher,
      city = pubnonperiodical.city,
      state = pubnonperiodical.state,
      _year18 = pubnonperiodical.year,
      start = pubnonperiodical.start,
      end = pubnonperiodical.end;
    if (!_title4 || !_year18 || !publisher || !city || !state || !start || !end) return true;
  }
  if (pubother) {
    var _city2 = pubother.city,
      _state2 = pubother.state,
      location = pubother.location;
    if (!location || !_city2 || !_state2) return true;
  }
  return validateContributors(contributors);
};
var validatePressFields = function validatePressFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data18 = citationData.data,
    pubonline = _citationData$data18.pubonline,
    pubnonperiodical = _citationData$data18.pubnonperiodical,
    pubother = _citationData$data18.pubother;
  if (pubnonperiodical) {
    var publisher = pubnonperiodical.publisher,
      city = pubnonperiodical.city,
      state = pubnonperiodical.state,
      year = pubnonperiodical.year;
    if (!state || !city || !year || !publisher) return true;
  }
  if (pubonline) {
    var title = pubonline.title,
      url = pubonline.url,
      _year19 = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!title || !url || !_year19 || !yearaccessed) return true;
  }
  if (pubother) {
    var _city3 = pubother.city,
      _state3 = pubother.state,
      _year20 = pubother.year;
    if (!_city3 || !_state3 || !_year20) return true;
  }
  return !contributors;
};
var validateTvRadioFields = function validateTvRadioFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data19 = citationData.data,
    pubtvr = _citationData$data19.pubtvr,
    pubonline = _citationData$data19.pubonline,
    pubtype = _citationData$data19.pubtype,
    tv = _citationData$data19.tv;
  var type = pubtype.suffix;
  if (tv) {
    var season = tv.season,
      episode = tv.episode;
    if (!season || !episode) return true;
  }
  if (pubtvr) {
    var year = pubtvr.year;
    if (!year) return true;
  }
  if (type === 'pubonline') {
    if (pubonline) {
      var title = pubonline.title,
        url = pubonline.url,
        _year21 = pubonline.year,
        yearaccessed = pubonline.yearaccessed;
      if (!title || !url || !_year21 || !yearaccessed) return true;
    }
  }
  return validateContributors(contributors);
};
var validateMultivolumeFields = function validateMultivolumeFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data20 = citationData.data,
    pubnonperiodical = _citationData$data20.pubnonperiodical,
    pubonline = _citationData$data20.pubonline,
    pubdatabase = _citationData$data20.pubdatabase;
  if (pubnonperiodical) {
    var _citationData$data$Ci8 = citationData.data[CitationPubTypeEnum.PUBNONPERIODICAL],
      city = _citationData$data$Ci8.city,
      publisher = _citationData$data$Ci8.publisher,
      state = _citationData$data$Ci8.state,
      title = _citationData$data$Ci8.title,
      year = _citationData$data$Ci8.year;
    if (!city || !publisher || !state || !year || !title) return true;
  }
  if (pubonline) {
    var _citationData$data$Ci9 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      _title5 = _citationData$data$Ci9.title,
      url = _citationData$data$Ci9.url,
      _year22 = _citationData$data$Ci9.year,
      yearaccessed = _citationData$data$Ci9.yearaccessed;
    if (!_title5 || !url || !_year22 || !yearaccessed) return true;
  }
  if (pubdatabase) {
    var _yearaccessed7 = citationData.data[CitationPubTypeEnum.PUBDATABASE].yearaccessed;
    if (!_yearaccessed7) return true;
  }
  return validateContributors(contributors);
};
var validateMusicalRecordingFields = function validateMusicalRecordingFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data21 = citationData.data,
    pubonline = _citationData$data21.pubonline,
    pubdatabase = _citationData$data21.pubdatabase;
  if (pubonline) {
    var title = pubonline.title,
      url = pubonline.url,
      year = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!title || !url || !year || !yearaccessed) return true;
  }
  if (pubdatabase && !pubdatabase.yearaccessed) return true;
  return validateContributors(contributors);
};
var validateScholarlyProjectFields = function validateScholarlyProjectFields(citationData) {
  var contributors = citationData.contributors;
  var pubonline = citationData.data.pubonline;
  if (pubonline) {
    var title = pubonline.title,
      url = pubonline.url,
      year = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!title || !url || !year || !yearaccessed) return true;
  }
  return validateContributors(contributors);
};
var validateReportFields = function validateReportFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data22 = citationData.data,
    pubnonperiodical = _citationData$data22.pubnonperiodical,
    pubonline = _citationData$data22.pubonline,
    pubdatabase = _citationData$data22.pubdatabase;
  if (pubnonperiodical) {
    var title = pubnonperiodical.title,
      start = pubnonperiodical.start,
      end = pubnonperiodical.end,
      publisher = pubnonperiodical.publisher,
      city = pubnonperiodical.city,
      state = pubnonperiodical.state,
      year = pubnonperiodical.year;
    if (!title || !start || !end || !publisher || !year || !city || !state) return true;
  }
  if (pubonline) {
    var url = pubonline.url,
      _title6 = pubonline.title,
      _year23 = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!url || !_title6 || !_year23 || !yearaccessed) return true;
  }
  if (pubdatabase && !pubdatabase.yearaccessed) {
    return true;
  }
  return validateContributors(contributors);
};
var validateMiscellaneousFields = function validateMiscellaneousFields(citationData) {
  var contributors = citationData.contributors;
  var pubother = citationData.data.pubother;
  if (pubother) {
    var city = pubother.city,
      location = pubother.location;
    if (!city || !location) return true;
  }
  return validateContributors(contributors);
};
var validateBibleFields = function validateBibleFields(citationData) {
  var _citationData$data23 = citationData.data,
    pubnonperiodical = _citationData$data23.pubnonperiodical,
    pubonline = _citationData$data23.pubonline,
    pubdatabase = _citationData$data23.pubdatabase;
  if (pubnonperiodical) {
    var title = pubnonperiodical.title,
      publisher = pubnonperiodical.publisher,
      city = pubnonperiodical.city,
      state = pubnonperiodical.state,
      year = pubnonperiodical.year;
    if (!title || !publisher || !year || !city || !state) return true;
  }
  if (pubonline) {
    var _title7 = pubonline.title,
      url = pubonline.url,
      _year24 = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!url || !_year24 || !yearaccessed || !_title7) return true;
  }
  if (pubdatabase && !pubdatabase.yearaccessed) return true;
  return false;
};
var validateBrochureFields = function validateBrochureFields(citationData) {
  var _citationData$data24 = citationData.data,
    pubnonperiodical = _citationData$data24.pubnonperiodical,
    pubonline = _citationData$data24.pubonline;
  if (pubnonperiodical) {
    var title = pubnonperiodical.title,
      publisher = pubnonperiodical.publisher,
      city = pubnonperiodical.city,
      state = pubnonperiodical.state,
      year = pubnonperiodical.year;
    if (!title || !publisher || !year || !city || !state) return true;
  }
  if (pubonline) {
    var _title8 = pubonline.title,
      url = pubonline.url,
      _year25 = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!url || !_year25 || !yearaccessed || !_title8) return true;
  }
  return false;
};
var validateConferenceFields = function validateConferenceFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data25 = citationData.data,
    pubmagazine = _citationData$data25.pubmagazine,
    pubonline = _citationData$data25.pubonline,
    pubdatabase = _citationData$data25.pubdatabase,
    pubnonperiodical = _citationData$data25.pubnonperiodical,
    conference = _citationData$data25.conference;
  if (conference) {
    var title = conference.title,
      title2 = conference.title2;
    if (!title || !title2) return true;
  }
  if (pubnonperiodical) {
    var _title9 = pubnonperiodical.title,
      publisher = pubnonperiodical.publisher,
      city = pubnonperiodical.city,
      state = pubnonperiodical.state,
      year = pubnonperiodical.year,
      start = pubnonperiodical.start,
      end = pubnonperiodical.end;
    if (!_title9 || !publisher || !year || !city || !state || !start || !end) return true;
  }
  if (pubmagazine) {
    var _year26 = pubmagazine.year;
    if (!_year26) return true;
  }
  if (pubonline) {
    var _title10 = pubonline.title,
      url = pubonline.url,
      _year27 = pubonline.year,
      yearaccessed = pubonline.yearaccessed;
    if (!_title10 || !url || !_year27 || !yearaccessed) return true;
  }
  if (pubdatabase && !pubdatabase.yearaccessed) return true;
  return validateContributors(contributors);
};
var validatePaintingFields = function validatePaintingFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data26 = citationData.data,
    pubtype = _citationData$data26.pubtype,
    pubnonperiodical = _citationData$data26.pubnonperiodical,
    pubonline = _citationData$data26.pubonline,
    pubdatabase = _citationData$data26.pubdatabase,
    painting = _citationData$data26.painting;
  if (pubtype.main === '' && pubtype.suffix === '') {
    if (painting) {
      var publisher = painting.publisher,
        publisherlocation = painting.publisherlocation;
      if (!publisher || !publisherlocation) return true;
    }
  }
  if (pubdatabase) {
    var yearaccessed = pubdatabase.yearaccessed;
    if (!yearaccessed) return true;
  }
  if (pubonline) {
    var title = pubonline.title,
      url = pubonline.url,
      year = pubonline.year,
      _yearaccessed8 = pubonline.yearaccessed;
    if (!title || !url || !year || !_yearaccessed8) return true;
  }
  if (pubnonperiodical) {
    var _title11 = pubnonperiodical.title,
      _publisher2 = pubnonperiodical.publisher,
      city = pubnonperiodical.city,
      state = pubnonperiodical.state,
      _year28 = pubnonperiodical.year,
      start = pubnonperiodical.start,
      end = pubnonperiodical.end;
    if (!_title11 || !_year28 || !_publisher2 || !city || !state || !start || !end) return true;
  }
  return validateContributors(contributors);
};
var validateCartoonFields = function validateCartoonFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data27 = citationData.data,
    pubnonperiodical = _citationData$data27.pubnonperiodical,
    pubonline = _citationData$data27.pubonline,
    pubmagazine = _citationData$data27.pubmagazine,
    pubnewspaper = _citationData$data27.pubnewspaper;
  if (pubnonperiodical) {
    var city = pubnonperiodical.city,
      publisher = pubnonperiodical.publisher,
      state = pubnonperiodical.state,
      title = pubnonperiodical.title,
      year = pubnonperiodical.year,
      start = pubnonperiodical.start,
      end = pubnonperiodical.end;
    if (!city || !publisher || !state || !year || !title || !start || !end) return true;
  }
  if (pubonline) {
    var _citationData$data$Ci10 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      _title12 = _citationData$data$Ci10.title,
      url = _citationData$data$Ci10.url,
      _year29 = _citationData$data$Ci10.year,
      yearaccessed = _citationData$data$Ci10.yearaccessed;
    if (!_title12 || !url || !_year29 || !yearaccessed) return true;
  }
  if (pubmagazine) {
    var _year30 = citationData.data[CitationPubTypeEnum.PUBMAGAZINE].year;
    if (!_year30) return true;
  }
  if (pubnewspaper) {
    var _year31 = citationData.data[CitationPubTypeEnum.PUBNEWSPAPER].year;
    if (!_year31) return true;
  }
  return validateContributors(contributors);
};
var validateCongressFields = function validateCongressFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data28 = citationData.data,
    pubnonperiodical = _citationData$data28.pubnonperiodical,
    pubonline = _citationData$data28.pubonline,
    pubdatabase = _citationData$data28.pubdatabase,
    congress = _citationData$data28.congress;
  if (congress) {
    var bill = congress.bill,
      committee = congress.committee,
      year = congress.year,
      session = congress.session;
    if (!bill || !committee || !year || !session) return true;
  }
  if (pubnonperiodical) {
    var city = pubnonperiodical.city,
      publisher = pubnonperiodical.publisher,
      state = pubnonperiodical.state,
      title = pubnonperiodical.title,
      _year32 = pubnonperiodical.year,
      start = pubnonperiodical.start,
      end = pubnonperiodical.end;
    if (!city || !publisher || !state || !_year32 || !title || !start || !end) return true;
  }
  if (pubonline) {
    var _citationData$data$Ci11 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      _title13 = _citationData$data$Ci11.title,
      url = _citationData$data$Ci11.url,
      _year33 = _citationData$data$Ci11.year,
      yearaccessed = _citationData$data$Ci11.yearaccessed;
    if (!_title13 || !url || !_year33 || !yearaccessed) return true;
  }
  if (pubdatabase) {
    var _yearaccessed9 = citationData.data[CitationPubTypeEnum.PUBDATABASE].yearaccessed;
    if (!_yearaccessed9) return true;
  }
  return validateContributors(contributors);
};
var validateEncyclopediaFields = function validateEncyclopediaFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data29 = citationData.data,
    pubnonperiodical = _citationData$data29.pubnonperiodical,
    pubonline = _citationData$data29.pubonline,
    pubdatabase = _citationData$data29.pubdatabase,
    encyclopedia = _citationData$data29.encyclopedia;
  if (encyclopedia) {
    var title = encyclopedia.title;
    if (!title) return true;
  }
  if (pubnonperiodical) {
    var city = pubnonperiodical.city,
      publisher = pubnonperiodical.publisher,
      state = pubnonperiodical.state,
      _title14 = pubnonperiodical.title,
      year = pubnonperiodical.year,
      start = pubnonperiodical.start,
      end = pubnonperiodical.end;
    if (!city || !publisher || !state || !year || !_title14 || !start || !end) return true;
  }
  if (pubonline) {
    var _citationData$data$Ci12 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      _title15 = _citationData$data$Ci12.title,
      url = _citationData$data$Ci12.url,
      _year34 = _citationData$data$Ci12.year,
      yearaccessed = _citationData$data$Ci12.yearaccessed;
    if (!_title15 || !url || !_year34 || !yearaccessed) return true;
  }
  if (pubdatabase) {
    var _yearaccessed10 = citationData.data[CitationPubTypeEnum.PUBDATABASE].yearaccessed;
    if (!_yearaccessed10) return true;
  }
  return validateContributors(contributors);
};
var validateDictionaryFields = function validateDictionaryFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data30 = citationData.data,
    pubnonperiodical = _citationData$data30.pubnonperiodical,
    pubonline = _citationData$data30.pubonline,
    pubdatabase = _citationData$data30.pubdatabase,
    dictionary = _citationData$data30.dictionary;
  if (dictionary) {
    var entry = dictionary.entry;
    if (!entry) return true;
  }
  if (pubnonperiodical) {
    var city = pubnonperiodical.city,
      publisher = pubnonperiodical.publisher,
      state = pubnonperiodical.state,
      title = pubnonperiodical.title,
      year = pubnonperiodical.year,
      start = pubnonperiodical.start,
      end = pubnonperiodical.end;
    if (!city || !publisher || !state || !year || !title || !start || !end) return true;
  }
  if (pubonline) {
    var _citationData$data$Ci13 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      _title16 = _citationData$data$Ci13.title,
      url = _citationData$data$Ci13.url,
      _year35 = _citationData$data$Ci13.year,
      yearaccessed = _citationData$data$Ci13.yearaccessed;
    if (!_title16 || !url || !_year35 || !yearaccessed) return true;
  }
  if (pubdatabase) {
    var _yearaccessed11 = citationData.data[CitationPubTypeEnum.PUBDATABASE].yearaccessed;
    if (!_yearaccessed11) return true;
  }
  return validateContributors(contributors);
};
var validateEmailFields = function validateEmailFields(citationData) {
  var contributors = citationData.contributors;
  var pubother = citationData.data.pubother;
  if (pubother) {
    var year = pubother.year;
    if (!year) return true;
  }
  return validateContributors(contributors);
};
var validateExecutiveOrderFields = function validateExecutiveOrderFields(citationData) {
  var pubfederal = citationData.data.pubfederal;
  var year = pubfederal.year;
  return !year;
};
var validateFederalBillFields = function validateFederalBillFields(citationData) {
  var _citationData$data31 = citationData.data,
    pubfederal = _citationData$data31.pubfederal,
    pubonline = _citationData$data31.pubonline,
    fedbill = _citationData$data31.fedbill;
  var billnumber = fedbill.billnumber,
    congnum = fedbill.congnum,
    title = fedbill.title,
    enacted = fedbill.enacted;
  if (fedbill) {
    if (!billnumber || !congnum) return true;
    if (enacted === 'unenacted' && !title) return true;
  }
  if (pubfederal) {
    var year = pubfederal.year,
      source = pubfederal.source,
      vol = pubfederal.vol;
    if (!year) return true;
    if (enacted === 'enacted' && (!source || !vol)) return true;
  }
  if (pubonline) {
    var _citationData$data$Ci14 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      _title17 = _citationData$data$Ci14.title,
      url = _citationData$data$Ci14.url,
      yearaccessed = _citationData$data$Ci14.yearaccessed;
    if (!_title17 || !url || !yearaccessed) return true;
  }
  return false;
};
var validateFederalReportFields = function validateFederalReportFields(citationData) {
  var pubfederal = citationData.data.pubfederal;
  var year = pubfederal.year,
    congress = pubfederal.congress;
  return !year || !congress;
};
var validateFederalRuleFields = function validateFederalRuleFields(citationData) {
  var pubfederal = citationData.data.pubfederal;
  var year = pubfederal.year,
    source = pubfederal.source,
    vol = pubfederal.vol;
  return !year || !source || !vol;
};
var validateFederalTestimonyFields = function validateFederalTestimonyFields(citationData) {
  var pubfederal = citationData.data.pubfederal;
  var year = pubfederal.year,
    congress = pubfederal.congress;
  return !year || !congress;
};
var validateFederalStatuteFields = function validateFederalStatuteFields(citationData) {
  var _citationData$data32 = citationData.data,
    pubfederal = _citationData$data32.pubfederal,
    statute = _citationData$data32.statute;
  var year = pubfederal.year,
    source = pubfederal.source,
    vol = pubfederal.vol,
    congress = pubfederal.congress;
  if (statute.codified === 'uncodified') return !congress;
  return !year || !source || !vol;
};
var validatePatentFields = function validatePatentFields(citationData) {
  var contributors = citationData.contributors;
  return validateContributors(contributors);
};
var validateMailingListFields = function validateMailingListFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data$pu = citationData.data.pubonline,
    title = _citationData$data$pu.title,
    url = _citationData$data$pu.url,
    year = _citationData$data$pu.year,
    yearaccessed = _citationData$data$pu.yearaccessed;
  var isPubOnlineReqFieldsEmpty = !title || !url || !year || !yearaccessed;
  return isPubOnlineReqFieldsEmpty || validateContributors(contributors);
};
var validateMicroformFields = function validateMicroformFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data33 = citationData.data,
    pubnonperiodical = _citationData$data33.pubnonperiodical,
    pubnewspaper = _citationData$data33.pubnewspaper,
    pubmagazine = _citationData$data33.pubmagazine,
    pubjournal = _citationData$data33.pubjournal,
    pubmicrofilm = _citationData$data33.pubmicrofilm;
  if (pubjournal) {
    var year = citationData.data[CitationPubTypeEnum.PUBJOURNAL].year;
    if (!year) return true;
  }
  if (pubnewspaper) {
    var _year36 = citationData.data[CitationPubTypeEnum.PUBNEWSPAPER].year;
    if (!_year36) return true;
  }
  if (pubmagazine) {
    var _year37 = citationData.data[CitationPubTypeEnum.PUBMAGAZINE].year;
    if (!_year37) return true;
  }
  if (pubmicrofilm) {
    var _year38 = citationData.data[CitationPubTypeEnum.PUBMICROFILM].year;
    if (!_year38) return true;
  }
  if (pubnonperiodical) {
    var city = pubnonperiodical.city,
      publisher = pubnonperiodical.publisher,
      state = pubnonperiodical.state,
      title = pubnonperiodical.title,
      _year39 = pubnonperiodical.year,
      start = pubnonperiodical.start,
      end = pubnonperiodical.end;
    if (!city || !publisher || !state || !_year39 || !title || !start || !end) return true;
  }
  return validateContributors(contributors);
};
var validateNewsletterFields = function validateNewsletterFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data34 = citationData.data,
    pubonline = _citationData$data34.pubonline,
    pubdatabase = _citationData$data34.pubdatabase;
  if (pubonline) {
    var _citationData$data$Ci15 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      title = _citationData$data$Ci15.title,
      url = _citationData$data$Ci15.url,
      year = _citationData$data$Ci15.year,
      yearaccessed = _citationData$data$Ci15.yearaccessed;
    if (!title || !url || !year || !yearaccessed) return true;
  }
  if (pubdatabase) {
    var _yearaccessed12 = citationData.data[CitationPubTypeEnum.PUBDATABASE].yearaccessed;
    if (!_yearaccessed12) return true;
  }
  return validateContributors(contributors);
};
var validateMapFields = function validateMapFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data35 = citationData.data,
    pubnonperiodical = _citationData$data35.pubnonperiodical,
    pubdatabase = _citationData$data35.pubdatabase,
    pubonline = _citationData$data35.pubonline;
  if (pubonline) {
    var _citationData$data$Ci16 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      title = _citationData$data$Ci16.title,
      url = _citationData$data$Ci16.url,
      year = _citationData$data$Ci16.year,
      yearaccessed = _citationData$data$Ci16.yearaccessed;
    if (!title || !url || !year || !yearaccessed) return true;
  }
  var isPubNonReqFieldsEmpty = false;
  if (pubnonperiodical) {
    var _title18 = pubnonperiodical.title,
      publisher = pubnonperiodical.publisher,
      city = pubnonperiodical.city,
      state = pubnonperiodical.state,
      _year40 = pubnonperiodical.year,
      start = pubnonperiodical.start,
      end = pubnonperiodical.end;
    isPubNonReqFieldsEmpty = [_title18, publisher, city, state, _year40, start, end].some(function (field) {
      return !field;
    });
  }
  var isPubDatabaseReqFieldsEmpty = false;
  if (pubdatabase) {
    var _yearaccessed13 = pubdatabase.yearaccessed;
    isPubDatabaseReqFieldsEmpty = !_yearaccessed13;
  }
  return isPubNonReqFieldsEmpty || isPubDatabaseReqFieldsEmpty || validateContributors(contributors);
};
var validatePamphletFields = function validatePamphletFields(citationData) {
  var contributors = citationData.contributors;
  var pubnonperiodical = citationData.data.pubnonperiodical;
  if (pubnonperiodical) {
    var city = pubnonperiodical.city,
      publisher = pubnonperiodical.publisher,
      state = pubnonperiodical.state,
      title = pubnonperiodical.title,
      year = pubnonperiodical.year;
    if (!city || !publisher || !state || !year || !title) return true;
  }
  return validateContributors(contributors);
};
var validateRawDataFields = function validateRawDataFields(citationData) {
  var contributors = citationData.contributors;
  var pubother = citationData.data.pubother;
  var location = pubother.location,
    city = pubother.city,
    year = pubother.year;
  if (!location || !city || !year) return true;
  return validateContributors(contributors);
};
var validatePerformanceFields = function validatePerformanceFields(citationData) {
  var contributors = citationData.contributors;
  var year = citationData.data.publive.year;
  if (!year) return true;
  return validateContributors(contributors);
};
var validateManuscriptFields = function validateManuscriptFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data36 = citationData.data,
    pubnonperiodical = _citationData$data36.pubnonperiodical,
    pubonline = _citationData$data36.pubonline,
    pubdatabase = _citationData$data36.pubdatabase;
  if (pubonline) {
    var _citationData$data$Ci17 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      _title19 = _citationData$data$Ci17.title,
      url = _citationData$data$Ci17.url,
      _year41 = _citationData$data$Ci17.year,
      yearaccessed = _citationData$data$Ci17.yearaccessed;
    if (!_title19 || !url || !_year41 || !yearaccessed) return true;
  }
  if (pubdatabase) {
    var _yearaccessed14 = citationData.data[CitationPubTypeEnum.PUBDATABASE].yearaccessed;
    if (!_yearaccessed14) return true;
  }
  var city = pubnonperiodical.city,
    title = pubnonperiodical.title,
    year = pubnonperiodical.year;
  if (!city || !year || !title) return true;
  return validateContributors(contributors);
};
var validateSoftwareFields = function validateSoftwareFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data37 = citationData.data,
    pubonline = _citationData$data37.pubonline,
    pubother = _citationData$data37.pubother,
    software = _citationData$data37.software;
  if (pubonline) {
    var _citationData$data$Ci18 = citationData.data[CitationPubTypeEnum.PUBONLINE],
      _title20 = _citationData$data$Ci18.title,
      url = _citationData$data$Ci18.url,
      year = _citationData$data$Ci18.year,
      yearaccessed = _citationData$data$Ci18.yearaccessed;
    if (!_title20 || !url || !year || !yearaccessed) return true;
  }
  if (pubother) {
    var _citationData$data$Ci19 = citationData.data[CitationPubTypeEnum.PUBOTHER],
      city = _citationData$data$Ci19.city,
      org = _citationData$data$Ci19.org,
      _year42 = _citationData$data$Ci19.year;
    if (!city || !org || !_year42) return true;
  }
  var title = software.title;
  return !title || validateContributors(contributors);
};
var validateReprintedWorkFields = function validateReprintedWorkFields(citationData) {
  var contributors = citationData.contributors;
  var _citationData$data38 = citationData.data,
    pubnonperiodical = _citationData$data38.pubnonperiodical,
    pubnewspaper = _citationData$data38.pubnewspaper,
    pubmagazine = _citationData$data38.pubmagazine,
    pubjournal = _citationData$data38.pubjournal,
    pubdatabase = _citationData$data38.pubdatabase;
  if (pubjournal) {
    var year = citationData.data[CitationPubTypeEnum.PUBJOURNAL].year;
    if (!year) return true;
  }
  if (pubnewspaper) {
    var _year43 = citationData.data[CitationPubTypeEnum.PUBNEWSPAPER].year;
    if (!_year43) return true;
  }
  if (pubmagazine) {
    var _year44 = citationData.data[CitationPubTypeEnum.PUBMAGAZINE].year;
    if (!_year44) return true;
  }
  if (pubdatabase) {
    var yearaccessed = citationData.data[CitationPubTypeEnum.PUBDATABASE].yearaccessed;
    if (!yearaccessed) return true;
  }
  if (pubnonperiodical) {
    var city = pubnonperiodical.city,
      publisher = pubnonperiodical.publisher,
      state = pubnonperiodical.state,
      title = pubnonperiodical.title,
      _year45 = pubnonperiodical.year,
      start = pubnonperiodical.start,
      end = pubnonperiodical.end;
    if (!city || !publisher || !state || !_year45 || !title || !start || !end) return true;
  }
  return validateContributors(contributors);
};

/**
 * return true if required fields in form are empty otherwise false
 */
export var validateMissingFormFields = function validateMissingFormFields(citationData) {
  var _citationData$sourceT;
  switch (((_citationData$sourceT = citationData.sourceType) === null || _citationData$sourceT === void 0 ? void 0 : _citationData$sourceT.toLowerCase()) || citationData.data.source) {
    case CitationTypes.WEBSITE:
      return validateWebsiteFields(citationData);
    case CitationTypes.BOOK:
      return validateBookFields(citationData);
    case CitationTypes.CHAPTER:
      return validateChapterFields(citationData);
    case CitationTypes.INTRODUCTION:
      return validateIntroductionFields(citationData);
    case CitationTypes.JOURNAL:
      return validateJournalFields(citationData);
    case CitationTypes.DIGITAL_FILE:
      return validateDigitalFileFields(citationData);
    case CitationTypes.DISSERTATION:
    case CitationTypes.THESIS:
      return validateDissertationThesisFields(citationData);
    case CitationTypes.FILM_ONLINE_VIDEO:
      return validateFilmFields(citationData);
    case CitationTypes.GOVERNMENT_PUBLICATION:
      return validateGovtPubFields(citationData);
    case CitationTypes.DIGITAL_IMAGE:
      return validateDigitalImageFields(citationData);
    case CitationTypes.ONLINE_DATABASE:
      return validateOnlineDatabaseFields(citationData);
    case CitationTypes.EDITORIAL:
    case CitationTypes.MAGAZINE:
    case CitationTypes.NEWSPAPER:
      return validateEditorialFields(citationData);
    case CitationTypes.REVIEW:
      return validateReviewFields(citationData);
    case CitationTypes.BLOG:
      return validateBlogFields(citationData);
    case CitationTypes.PHOTO:
      return validatePhotoFormFields(citationData);
    case CitationTypes.INTERVIEW:
      return validateInterviewFields(citationData);
    case CitationTypes.COURTCASE:
      return validateCourtcaseFormFields(citationData);
    case CitationTypes.PRESS:
      return validatePressFields(citationData);
    case CitationTypes.TV_RADIO:
      return validateTvRadioFields(citationData);
    case CitationTypes.ADVERTISEMENT:
      return validateAdvertisementFields(citationData);
    case CitationTypes.SCHOLARLY_PROJECT:
      return validateScholarlyProjectFields(citationData);
    case CitationTypes.MULTIVOLUME:
      return validateMultivolumeFields(citationData);
    case CitationTypes.MUSICAL_RECORDING:
      return validateMusicalRecordingFields(citationData);
    case CitationTypes.LETTER:
      return validateLetterFields(citationData);
    case CitationTypes.REPORT:
      return validateReportFields(citationData);
    case CitationTypes.MISCELLANEOUS:
      return validateMiscellaneousFields(citationData);
    case CitationTypes.BIBLE:
      return validateBibleFields(citationData);
    case CitationTypes.BROCHURE:
      return validateBrochureFields(citationData);
    case CitationTypes.CONFERENCE:
      return validateConferenceFields(citationData);
    case CitationTypes.PAINTING:
      return validatePaintingFields(citationData);
    case CitationTypes.LECTURE:
      return validateLectureFormFields(citationData);
    case CitationTypes.CARTOON:
      return validateCartoonFields(citationData);
    case CitationTypes.CONGRESS:
      return validateCongressFields(citationData);
    case CitationTypes.ENCYCLOPEDIA:
      return validateEncyclopediaFields(citationData);
    case CitationTypes.DICTIONARY:
      return validateDictionaryFields(citationData);
    case CitationTypes.EMAIL:
      return validateEmailFields(citationData);
    case CitationTypes.EXECUTIVE_ORDER:
      return validateExecutiveOrderFields(citationData);
    case CitationTypes.FEDERAL_BILL:
      return validateFederalBillFields(citationData);
    case CitationTypes.FEDERAL_REPORT:
      return validateFederalReportFields(citationData);
    case CitationTypes.FEDERAL_RULE:
      return validateFederalRuleFields(citationData);
    case CitationTypes.FEDERAL_TESTIMONY:
      return validateFederalTestimonyFields(citationData);
    case CitationTypes.FEDERAL_STATUTE:
      return validateFederalStatuteFields(citationData);
    case CitationTypes.PATENT:
      return validatePatentFields(citationData);
    case CitationTypes.MAILING_LIST:
    case CitationTypes.NEWSGROUP:
      return validateMailingListFields(citationData);
    case CitationTypes.MICROFORM:
      return validateMicroformFields(citationData);
    case CitationTypes.NEWSLETTER:
      return validateNewsletterFields(citationData);
    case CitationTypes.MAP:
      return validateMapFields(citationData);
    case CitationTypes.PAMPHLET:
      return validatePamphletFields(citationData);
    case CitationTypes.RAW_DATA:
      return validateRawDataFields(citationData);
    case CitationTypes.PERFORMANCE:
      return validatePerformanceFields(citationData);
    case CitationTypes.MANUSCRIPT:
      return validateManuscriptFields(citationData);
    case CitationTypes.SOFTWARE:
      return validateSoftwareFields(citationData);
    case CitationTypes.REPRINTED_WORK:
      return validateReprintedWorkFields(citationData);
    case CitationTypes.DISSERTATION_ABSTRACT:
      return validateDisserationAbstractFields(citationData);
    default:
      return false;
  }
};